import { css } from '@emotion/react';
export default $ => css`
  .workpage {
    padding-top: 8px;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    height: 100%;
    gap: 16px;
    background-color: #ffffff;
    &:has(> .workpage-widget:only-child > .cardtray:only-child),
    &:has(> .workpage-widget:only-child > .worktray:only-child) {
      grid-template-rows: 1fr;
    }
    .dashboard {
      height: 100%;
    }
    .workpage-widget {
      height: 100%;
      min-height: 0;
      min-width: 0;
    }
  }
  .workTrayIcon {
    padding-bottom: 20px;
    img {
      cursor: pointer;
      max-width: 143px;
    }
    .label {
      p {
        font-size: 19px !important;
        margin: 0px;
        font-weight: bold;
      }
    }
  }
  .td-actionButtons {
    display: flex;
    justify-content: space-between;
    gap: 5px;
  }
  .worktray {
    height: 100%;
    display: flex;
    flex-direction: column;
    > .card:not(:first-of-type) {
      flex-grow: 1;
      min-height: 0;
    }
    > .card {
      position: relative;
      > .card-header {
        & .worktray-description {
          margin-top: -6px;
        }

        .worktray-header-left {
          display: flex;
          align-items: center;
        }
      }
      > .worktray-table-container {
        min-height: 100px;
        width: 100%;
        height: 100%;
        overflow: auto;
        position: relative;
        &.full-height > .table {
          height: 100%;
        }
        > .table {
          flex-grow: 1;
          margin-bottom: 0;
          overflow: visible;

          th {
            text-align: left !important;
          }

          > thead {
            position: sticky;
            top: 0;
            background-color: #ffffff;
            z-index: 1;
          }
          > * > tr {
            > td,
            > th {
              padding: 0.32rem 0rem 0.32rem 0.25rem;
              > .btn {
                white-space: nowrap;
                text-overflow: clip;
                margin: auto;
              }
            }
          }
          .loader-container {
            background-color: #ffffff;
            > td {
              vertical-align: middle;
            }
          }
          .empty-state {
            text-align: center;
            padding: 1rem 0;
            width: fit-content;
            margin: auto;
            padding-left: 2rem;
            padding-right: 2rem;
          }
          .error-container > td {
            height: fit-content;
          }
        }
      }
    }

    /* ── Flat layout (ui:asCard === false) ─────────────────────────────────── */
    &.worktray--flat {
      .filter-button {
        flex-shrink: 0;
        border: 0 !important;
      }

      > .card {
        display: none; /* hide any stray card wrappers */
      }

      .worktray-flat-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1rem;
        flex-shrink: 0;

        .title {
          white-space: nowrap;
        }

        .filter-button {
          flex-shrink: 0;
          color: ${$.gray500};
          border: 0 !important;
          transition: transofrm 250ms ease-in-out;
          box-shadow: none;
          padding-left: 4px;
          padding-right: 4px;
          box-shadow: none !important;

          &:hover,
          &:active,
          &.active {
            box-shadow: none !important;
            background: transparent !important;
            color: ${$.gray400} !important;
            transform: scale(1.3) !important;
          }
        }

        .worktray-flat-header-title {
          display: flex;
          flex-direction: column;
          gap: 0.15rem;

          h4 {
            margin: 0;
            font-size: 1.15rem;
            font-weight: 600;
            line-height: 1.3;
          }

          small {
            font-size: 0.8125rem;
          }
        }

        .filter-button {
          flex-shrink: 0;
        }
      }

      .worktray-filters-collapse {
        // margin-bottom: 1rem;
        flex-shrink: 0;
      }

      .worktray-flat-scroll {
        flex: 1;
        min-height: 0;
        overflow-y: auto;

        > .worktray-table-container {
          .action-buttons-cell {
            text-align: center;
            vertical-align: middle;
            > .btn {
              padding: 4px 8px;
              margin-right: 4px;
              margin-top: 1px;
              margin-bottom: 1px;
            }
          }
          min-height: 100px;
          width: 100%;
          height: 100%;
          overflow: auto;
          position: relative;
          &.full-height > .table {
            height: 100%;
          }
          > .table {
            flex-grow: 1;
            margin-bottom: 0;
            overflow: visible;
            > thead {
              position: sticky;
              top: 0;
              background-color: #ffffff;
              z-index: 1;

              > tr > th {
                border-bottom: 2px solid ${$.gray400} !important;
              }
            }
            > * > tr {
              > td,
              > th {
                padding: 0.32rem 0rem 0.32rem 0.25rem;
                > .btn {
                  white-space: nowrap;
                  text-overflow: clip;
                }
              }
            }
            .loader-container {
              background-color: #ffffff;
              > td {
                vertical-align: middle;
              }
            }
            .empty-state {
              text-align: center;
              padding: 1rem 0;
              width: fit-content;
              margin: auto;
              padding-left: 2rem;
              padding-right: 2rem;
            }
            .error-container > td {
              height: fit-content;
            }
          }
        }
      }

      .worktray-flat-pagination {
        margin-top: 0.5rem;
        flex-shrink: 0;
      }
    }
  }
  .show-when-mobile {
    display: none;
  }
  .worktray-datacell {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
  }
  @media (max-width: 850px) {
    .mobile-workpage {
      height: auto;
      display: flex;
      flex-direction: column;
      &:has(> :only-child) {
        height: 100%;
      }
    }
    .worktray-table-container {
      display: none;
    }
    .mobile-table {
      > div:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, 0.05);
      }
      > .card {
        border: none;
      }
      > .empty-state,
      > .loader-container {
        padding: 2rem;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        > .alert {
          width: fit-content;
          padding-left: 2rem;
          padding-right: 2rem;
        }
      }
    }
    @media (max-width: 768px) {
      .worktray > .card > .card-header .worktray-description {
        display: none;
      }
    }
  }
  td.worktray-row--past {
    opacity: 0.5;
  }

  .workpage .workpage-widget:only-child .dashboard:only-child {
    margin-top: -8px;
    margin-left: -1rem;
    margin-right: -1rem;
  }
`;
